module.exports = __webpack_public_path__ + "img/down_csv_btn.dcc8ee40.svg";